import React from 'react';
import { IntlProvider } from 'react-intl';
import sw from 'translations/swedish';
import en from 'translations/english';
import { useMemo } from 'react';
import { useLocale } from 'services/user/locale/hook';
import { SWEDISH, ENGLISH } from 'services/user/locale/utils';
import { useTenantConfig } from 'global/tenant-config';

export const TranslationsProvider = ({ children }) => {
  const { tenantConfig } = useTenantConfig();
  const { intl: { swedish: tenantSwedish, english: tenantEnglish } } = tenantConfig;

  const languages = useMemo(() => (
    {
      [SWEDISH]: { ...sw, ...tenantSwedish },
      [ENGLISH]: { ...en, ...tenantEnglish }
    }
    ), [tenantSwedish, tenantEnglish]);

  const { locale } = useLocale();

  return (
    <IntlProvider
      locale={locale}
      messages={languages[locale]}
    >
      {children}
    </IntlProvider>
  )
};
